import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {RxComponent} from '../../../core/components/common/rx.component';
import {Observable} from 'rxjs';
import {NotificationService} from '../../../core/services/notification.service';
import {ExamResultsCertificatesService} from './exam-results-certificates.service';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'happy-exam-results-certificates',
    templateUrl: 'happy-exam-results-certificates.component.html',
    styleUrls: ['happy-exam-results-certificates.component.css']
})

export class HappyExamResultsCertificatesComponent extends RxComponent {

    @Input() private examFulfillment: any;
    private fields: any[];
    private learners = [];
    private languages: { key: string, value: string }[];
    private table: ElementRef;
    @ViewChild('table') set content(content: ElementRef) {
        this.table = content;
        setTimeout(this.checkOverflow(), 50);
    }

    constructor(
        private service: ExamResultsCertificatesService,
        private notificationService: NotificationService
    ) {
        super();
    }

    ngOnInit() {
        this.fields = [
            'Email',
            'Learner Details',
            'Leapest Voucher',
            'Supplier Voucher / Session ID',
            'Results',
            'Certificate'
        ];

        this.service.getLanguages().bindToLifecycle(this).subscribe(res => this.languages = res);

        this.service.getLearners(this.examFulfillment.exam.id).subscribe(data => this.updateLearners(data));
    }

    private updateLearners(data) {
        this.learners = data.filter(learner => learner.voucherDetails);
        setTimeout(this.checkOverflow, 50);
    }

    private getLanguageName(key: string): string {
        if(key)
            return this.languages ? this.languages.find(itr => itr.key === key).value : '';
        return '';
    }

    private checkOverflow() {
        if (!this.table)
            return;
        let overflow: number = this.table.nativeElement.parentElement.offsetWidth - this.table.nativeElement.parentElement.clientWidth;
        overflow = overflow ? overflow + 1 : 7;
        if (this.table.nativeElement.clientHeight > this.table.nativeElement.parentElement.clientHeight) {
            this.table.nativeElement.parentElement.style.marginRight = `-${overflow}px`;
            this.table.nativeElement.parentElement.style.paddingRight = '1px';
        } else {
            this.table.nativeElement.parentElement.style.marginRight = '0';
            this.table.nativeElement.parentElement.style.paddingRight = '0';
            overflow = 0;
        }
    }

    saveResults(){
        if(this.learners) {
            let results = this.learners
                .map(learner => learner.voucherDetails)
                .filter(voucher => voucher.examStatus)
                .map(voucher => {
                    return {voucher: voucher.voucher, examStatus: voucher.examStatus};
                });
            this.service.saveResults(results)
                .subscribe(
                    _ => this.notificationService.success('Exam results successfully updated'),
                    err => this.notificationService.error('Error saving exam results'));
        }
    }

    issueCertificate(learner){
        if(learner){
            this.service.issueCertificate(learner.voucherDetails.voucher)
                .subscribe(_ => {
                    learner.voucherDetails.certificate.status = 'success';
                    this.notificationService.success('Certificate successfully issued');
                }, e => this.notificationService.error('Error issuing certificate'));
        }else{
            this.notificationService.error('No learner to issue certificate')
        }
    }

    examResultChanged(learner, examStatus: string) {
        const voucher = learner.voucherDetails.voucher;
        this.service.saveResults([{voucher, examStatus}])
            .flatMap(() => this.service.getLearners(this.examFulfillment.exam.id))
            .subscribe(
                data => {
                    this.notificationService.success('Exam results successfully updated');
                    this.updateLearners(data)
                },
                err => this.notificationService.error('Error saving exam results')
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/solar/common/results-certificates/happy-exam-results-certificates.component.ts